import React, { HTMLAttributes } from 'react';

export interface SpacerProps extends HTMLAttributes<HTMLDivElement> {
  height?: number;
}

const Spacer = ({ height, style, ...rest }: SpacerProps) => (
  <div
    style={{
      ...(height && { height: `${height}px`, width: 1 }),
      ...style,
    }}
    {...rest}
  />
);

export default Spacer;
